import React from "react";
import HeroLayout from "../components/HeroLayout";
import YouTubeVideo from "../components/YouTubeVideo";
const images = require.context("../assets/images", false);

function VideoReviews() {
  return (
        <>
    <HeroLayout>
    <div
        className="banner-bg"
        style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./Udaipur.jpg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Video Reviews</h1>
            </div>
        </div>
        </div>

</HeroLayout>
<div className="video-reviews mt-80">
  <div className="container">
    <div className="row">
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/oK4OnNv0wK0"
            title="Luxury Golden Triangle Tour | UK Guest Review / Feedback"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | UK Guest Review / Feedback</h3>
          </div>

        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/VBMcdOdreLk"
            title="Luxury Golden Triangle Tour | Guest Feedback/Testimonial"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>A family from USA on a Luxury Tour of India</h3>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/F90cOsjw0lU"
            title="Luxury Golden Triangle Tour | Feedback/Testimonial by couple from Spain, UK"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | Feedback/Testimonial by couple from Spain, UK</h3>
       
          </div>
          
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/5aWIB589zOo"
            title="Luxury Golden Triangle Tour | #Switzerland (#Swiss) guest feedback/Testimonial"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | #Switzerland (#Swiss) guest feedback/Testimonial</h3>

          </div>
          
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/1r9rRk2xpSI"
            title="A family from USA on a Luxury Tour of India."
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>A family from USA on a Luxury Tour of India</h3>
          </div>
          
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/Nqgfn-tdxpo"
            title="Luxury Golden Triangle Tour | United Kingdom #UK Guest Feedback"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | United Kingdom #UK Guest Feedback</h3>

          </div>
          
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/ocvwsnkA39I"
            title="Luxury Golden Triangle Tour | Bulgaria Guest Review/Feedback"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | Bulgaria Guest Review/Feedback</h3>
      
          </div>
          
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/P0LT3RPppuw"
            title="Luxury Golden Triangle Tour | #Mexico Guest Review/Feedback"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | #Mexico Guest Review/Feedback</h3>
            
          </div>
          
        </div>
      </div>
            <div className="col-md-6 col-lg-4">
        <div className="video-reviews-card">
          <YouTubeVideo
            width="100%"
            height="250px"
            src="https://www.youtube.com/embed/h7Wj1cMSEjk"
            title="Luxury Golden Triangle Tour | USA Guest Review"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen=""
          />
          <div className="video-reviews-text">
            <h3>Luxury Golden Triangle Tour | USA Guest Review</h3>
            
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default VideoReviews;
